
import { defineComponent, onMounted } from 'vue';
import {
    AppFormRow,
    AppInput,
    AppCard,
    AppSelect,
    AppFileUpload,
    AppImageHolder,
    AppButton,
    AppDateTimePicker
} from '@/components';
import { useLiveopsEdit } from '@/modules/liveops/item/model/edit';
import { LiveopsOptions } from '@/modules/liveops/item/types';

export default defineComponent({
    name: 'LiveopsEdit',
    components: {
        AppFormRow,
        AppInput,
        AppSelect,
        AppFileUpload,
        AppImageHolder,
        AppCard,
        AppButton,
        AppDateTimePicker
    },
    setup() {
        const { model, v$, fetch, actions } = useLiveopsEdit();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions, LiveopsOptions };
    }
});
